/**
 * Labstep
 *
 * @module components/ProtocolCollectionTemplate/EmptyState
 * @desc Empty state for ProtocolCollectionTemplate
 */

import { ProtocolCollectionActionCreateTemplate } from 'labstep-web/components/ProtocolCollection/Action/CreateTemplate';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';

export const ProtocolCollectionTemplateEmptyState: React.FC = () => (
  <CardEmptyState
    src="/img/empty-state/protocols.svg"
    title="No Protocol Templates"
    explanation="Create a protocol template to standardize procedures for your workspace."
    action={<ProtocolCollectionActionCreateTemplate />}
  />
);
